module.exports = __webpack_public_path__ + "static/media/logo_retos.1a320f92.png";